import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  IngestJiraResponse,
  IngestJunitResponse,
  type IngestJiraRequest,
  type IngestJunitRequest,
} from "@oracus/shared/api/ingest";

import { apiClient } from "./client.ts";

export function useIngestJunit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: IngestJunitRequest) =>
      apiClient.post("/api/ingest/junit", req, IngestJunitResponse),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["test-cases"] });
    },
  });
}

export function useIngestJira() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: IngestJiraRequest) =>
      apiClient.post("/api/ingest/jira", req, IngestJiraResponse),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["tickets"] });
    },
  });
}
